import { render } from "./Circle.vue?vue&type=template&id=1ecc90ab&scoped=true&ts=true"
import script from "./Circle.vue?vue&type=script&lang=ts"
export * from "./Circle.vue?vue&type=script&lang=ts"

import "./Circle.vue?vue&type=style&index=0&id=1ecc90ab&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ecc90ab"]])

export default __exports__